import { makeSvgIcon } from '../makeSvgIcon'

export const triangle = makeSvgIcon(<path d="M12 2L22.3923 20H1.6077L12 2Z" />)
